import { useState, useEffect } from 'react'
import { getListAdOptionsAvailable } from '../../../../services'
import { useModalPublishOrUnpublishPropertyStore } from '../../../../store'

import type { IListAvailable } from '../../../../../interfaces'
import {
  PORTAL_IDS_ASSIGNED_OPTIONS,
  PORTAL_IDS_WITH_OPTIONS,
  assignedAdvertisementByPortalId,
  assignedListAdOptionIdByPortalId
} from '../../../../constants'

interface IUseAdOptions {
  portalId: string
}

export const useAdOptions = ({ portalId }: IUseAdOptions) => {
  const modalType = useModalPublishOrUnpublishPropertyStore(
    (state) => state?.modalState?.type
  )

  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [adOptions, setAdOptions] = useState<IListAvailable[]>([])

  const fetchAdOption = async (portalIdList: string) => {
    try {
      setIsLoading(true)
      const { isSuccess, data } = await getListAdOptionsAvailable({
        portal: portalIdList
      })

      if (isSuccess && data) {
        setIsError(false)
        setAdOptions(data)
      } else {
        setIsError(true)
      }
    } catch {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  const generateAdOptions = () => {
    if (modalType === 'publish') {
      if (PORTAL_IDS_WITH_OPTIONS?.includes(portalId)) {
        const portalIdAssigned = assignedListAdOptionIdByPortalId[portalId]
        fetchAdOption(portalIdAssigned)
      }

      if (PORTAL_IDS_ASSIGNED_OPTIONS?.includes(portalId)) {
        const adOptionAssigned = assignedAdvertisementByPortalId[portalId]
        setAdOptions(adOptionAssigned)
      }
    }
  }

  useEffect(() => {
    if (adOptions?.length === 0) {
      generateAdOptions()
    }
  }, [])

  return {
    isLoading,
    adOptions,
    isError
  }
}
